'use client';

import { useQueryState, parseAsString } from 'nuqs';
import { useDeferredValue } from 'react';

/**
 * URL-persistenter Such-Hook via nuqs.
 * Der Suchbegriff wird als `?q=...` in der URL gespeichert
 * und überlebt Refresh / Bookmark / Share.
 */
export function useSearch() {
  const [query, setQuery] = useQueryState(
    'q',
    parseAsString.withDefault('').withOptions({ shallow: true, throttleMs: 300 }),
  );

  const deferredQuery = useDeferredValue(query);

  const clearSearch = () => setQuery('');

  return { query, deferredQuery, setQuery, clearSearch } as const;
}
